var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3484 6.79999C27.4756 6.79999 28.5566 7.24775 29.3536 8.04478C30.1507 8.84181 30.5984 9.92282 30.5984 11.05V24.65C30.5984 25.7772 30.1507 26.8582 29.3536 27.6552C28.5566 28.4522 27.4756 28.9 26.3484 28.9H7.64844C6.52127 28.9 5.44026 28.4522 4.64323 27.6552C3.8462 26.8582 3.39844 25.7772 3.39844 24.65V11.05C3.39844 9.92282 3.8462 8.84181 4.64323 8.04478C5.44026 7.24775 6.52127 6.79999 7.64844 6.79999H26.3484ZM28.8984 13.5337L17.4302 20.2827C17.3218 20.3463 17.2006 20.3852 17.0754 20.3963C16.9502 20.4075 16.824 20.3907 16.706 20.3473L16.5666 20.2827L5.09844 13.5371V24.65C5.09844 25.3263 5.3671 25.9749 5.84532 26.4531C6.32353 26.9313 6.97214 27.2 7.64844 27.2H26.3484C27.0247 27.2 27.6733 26.9313 28.1516 26.4531C28.6298 25.9749 28.8984 25.3263 28.8984 24.65V13.5337ZM26.3484 8.49999H7.64844C6.97214 8.49999 6.32353 8.76865 5.84532 9.24687C5.3671 9.72508 5.09844 10.3737 5.09844 11.05V11.5634L16.9984 18.564L28.8984 11.56V11.05C28.8984 10.3737 28.6298 9.72508 28.1516 9.24687C27.6733 8.76865 27.0247 8.49999 26.3484 8.49999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.0d2f2d51c83361bc6139748766176ce0.svg";
export { ForwardRef as ReactComponent };